import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {makeStyles} from '@mui/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import defaultAvatar from './../../assets/images/al_default_avatar.png';
import defaultStyle from './UserPublicProfileV2.module.scss';
import desktopPreviewStyle from './UserPublicProfile_desktop_previewV2.module.scss';
import mobilePreviewStyle from './UserPublicProfile_mobile_previewV2.module.scss';
import {ReactComponent as LocationDynamic} from './../../assets/images/icons/al_location_new.svg';
import alfanLogo from './../../assets/images/alfan_logo.svg';
import {useTranslation} from 'react-i18next';
import {envConfig} from './../../API/enviromentVariables';
import PublicProfileSectionCard from './../../components/PublicProfileSectionCard';
import ChargeCardTapModal from './../../components/ChargeCardTapModal/ChargeCardTapModal';
import {isRtl} from '../../features/util';
import {numberFollowerFormat} from '../../Helper/generalHelper';
import useWindowWidth from '../../hooks/useWindowWidth';
import {socialMediaLinks} from '../../constants/socialMedia';
import {previewStyles} from '../../constants/theme';
import nonHookRequest from '../../API/nonHookRequest';

interface IPublicUserProfile {
  mediakitUser: any;
  selectedStyle?: string;
  themeProp?: any;
  useOnlyLinksUser?: boolean;
}

const UserPublicProfile = ({
  mediakitUser,
  selectedStyle = 'default',
  themeProp,
}: IPublicUserProfile) => {
  const [openMonitizeModal, setOpenMonitizeModal] = useState(false);
  const [monitizeLinkID, setMonitizeLinkID] = useState('');
  const [clientSecret, setClientSecret] = useState<any>('');
  const [monetizeObj, setMonetizeObj] = useState<any>({type: '', title: '', note: '', attachment: '', amount: 0, url: '', maxPrice: 1000, minPrice: 1});
  const [activePaymentMethod, setActivePaymentMethod] = useState(envConfig().activePaymentMethod || 'stripe');
  const [selectedTab, setSelectedTab] = useState('rates');
  const theme = mediakitUser;
  const uniqueFollowerCount = mediakitUser?.displayFollower ? (numberFollowerFormat(mediakitUser?.followersCount || 0)) : 0;
  const mobile = selectedStyle === previewStyles.MOBILE_PREVIEW ? 760 : useWindowWidth();
  const {t, i18n} = useTranslation();
  const themeFont = theme.englishFont;
  const nickname = mediakitUser.nickname;

  const useStyles = makeStyles({
    tabs: {
      "& .MuiTabs-indicator": {
        backgroundColor: 'black',
      },
      "& .MuiTabs-flexContainer": {
        'justify-content': 'space-around',
      },
      "& .MuiTabs-scroller": {
        'border-bottom': '0.1px solid',
      },
    },
  });
  
  const classes = useStyles();

  // the avatar ifologic needs to be changed for when the avatar becomes an URL instead of an object
  const profileAvatar = mediakitUser ? (mediakitUser?.avatarUrl || defaultAvatar) : (theme.avatar || defaultAvatar);
  let backgroundImage = '';
  let socialMediaIconsStyle = {};
  let socialMediaIconsColor = '';
  let headerBorderRadius = '';

  let styles: any = '';
  if (selectedStyle === previewStyles.DESKTOP_PREVIEW) {
    styles = desktopPreviewStyle;
    backgroundImage = ''; // getImagePath({path: theme.desktopImage});
    socialMediaIconsColor = theme.desktopSocialMediaColor;
    headerBorderRadius = ''; // shapeData?.header.desktopPreviewBorderRadius!;
  }
  if (selectedStyle === previewStyles.MOBILE_PREVIEW) {
    styles = mobilePreviewStyle;
    socialMediaIconsStyle = {transform: 'scale(0.75)'};
    backgroundImage = ''; // getImagePath({path: theme.mobileImage});
    socialMediaIconsColor = theme.mobileSocialMediaColor;
    headerBorderRadius = ''; // shapeData?.header.mobilePreviewBorderRadius!;
  }
  if (selectedStyle === previewStyles.DEFAULT) {
    styles = defaultStyle;
    if (mobile < 768) {
      backgroundImage = ''; // getImagePath({path: theme.mobileImage});
      socialMediaIconsColor = theme.mobileSocialMediaColor;
      headerBorderRadius = ''; // shapeData?.header.mobileBorderRadius!;
    } else {
      backgroundImage = ''; // getImagePath({path: theme.desktopImage});
      socialMediaIconsColor = theme.desktopSocialMediaColor;
      headerBorderRadius = ''; // shapeData?.header.borderRadius!;
    }
  }

  // // SECTIONS
  const mediakitSections = mediakitUser.mediakitSection;

  // // SOCIAL MEDIA SECTION
  const userSocialMediaLinks = mediakitSections.find(
      (section: any) => section.type === 'social',
  )?.mediakitSectionLinks.slice().filter((e: any) => e?.isActive != false).sort((a:any, b:any) => a.orderNumber - b.orderNumber);

  const socialMediaData = userSocialMediaLinks?.map((item:any, index:number)=>{
    const dynamicData = socialMediaLinks.filter((soc:any)=>soc.key === item.platform);
    if (dynamicData.length && item.isVisible) {
      return (<div key={'social-icon-link'+index}
        className={styles.icon_main}
        onClick={() => {
          const regexp = new RegExp(item.platform, 'gm');
          if (item.url.match(regexp) && item.url.match(regexp).length>1) {
            const final = item.url.substr(item.url.lastIndexOf('/') + 1);
            item.url = 'https://' + item.platform + '.com/' + final;
          }
          handleOpenLink(item.url, item.id);
        }}
      >
        {/* {dynamicData[0].dynamic} */}
        <img style={{...socialMediaIconsStyle, cursor: 'pointer'}} className={styles.social_icons} src={dynamicData[0].defaultIconTransparent} />
        {!!item?.mediakitLinksInsights?.followersCount && mediakitUser?.displayFollower && <div className={styles.follower_individual}>{numberFollowerFormat(item?.mediakitLinksInsights?.followersCount || 0)}</div>}
      </div>);
    }
  });

  // // RATES LINKS SECTION
  const userRatesLinksParent = mediakitSections.find((section: any) => section.type === 'rates');
  const userRatesLinks = mediakitSections.find((section: any) => section.type === 'rates')?.mediakitSectionLinks?.filter((e: any) => (e?.isActive != false && e.isVisible));
  const ratesLinksData = (userRatesLinks?.length !== 0) && (
    <PublicProfileSectionCard
      theme={theme}
      id={userRatesLinksParent?.id}
      isVisible={userRatesLinksParent?.isVisible}
      mediakitSectionLinks={userRatesLinks}
      title={''}
      subtitle={userRatesLinksParent?.subtitle}
      type={userRatesLinksParent?.type}
      selectedStyle={selectedStyle}
      mediakitUserId={mediakitUser.id}
      ownerUserId={mediakitUser?.userId}
      key={'rates' + userRatesLinksParent?.id}
      nickname={nickname}
      email={mediakitUser?.publicEmail}
      setMonitizeID={setMonitizeLinkID}
      setMonetizeObj={setMonetizeObj}
      maxDesktopContainerWidth={'100%'}
    />
  );

  // // VIDEOS LINKS SECTION
  const userVideoLinksParent = mediakitSections.find((section: any) => section.type === 'video');
  const userVideoLinks = mediakitSections.find((section: any) => section.type === 'video')?.mediakitSectionLinks?.filter((e: any) => (e?.isActive != false && e.isVisible));
  const videoData = userVideoLinks?.length !== 0 && (
    <PublicProfileSectionCard
      theme={theme}
      id={userVideoLinksParent?.id}
      isVisible={userVideoLinksParent?.isVisible}
      mediakitSectionLinks={userVideoLinks}
      title={''}
      subtitle={''}
      type={userVideoLinksParent?.type}
      selectedStyle={selectedStyle}
      mediakitUserId={mediakitUser.id}
      key={'video' + userVideoLinksParent?.id}
      email={mediakitUser?.publicEmail}
      setMonitizeID={setMonitizeLinkID}
      enableSubtitle={true}
      maxDesktopContainerWidth={'100%'}
    />
  );

  const handleLinkCount = async (itemId?: any) => {
    if (mediakitUser && mediakitUser.userId && itemId) {
      await nonHookRequest({method: 'POST', url: '/analytics/linkClick/count', body: {linkId: itemId, nickname: nickname}});
    }
  };

  // FUNCTIONS
  const handleOpenLink = async (item: any, itemId?: any) => {
    if (!!item?.isMonitize) {
      if (selectedStyle === previewStyles.DEFAULT) {
        setMonitizeLinkID(itemId);
        handleLinkCount(itemId);
      } else {
         toast(<span style={{color: 'black'}}>{'Not active from this section!'}</span>, {autoClose: 3000});
      }
      return;
    }
    if (item == 'redirect_to_landing_page') {
      window.location.href = `/?redirect_via=create_link&link_user_id=${mediakitUser?.userId}`;
    } else {
      window.open(item.includes('http') ? item : '//'+ item, '_blank');
    }
    handleLinkCount(itemId);
  };

  const translate = (key : string) => {
    return t(key, {lng: theme.displayLocale});
  };


  const Footer = ()=>{
    return (<div className={styles.footer}
    >
      <div
        className={styles.addLinkButton}
        style={{color: mobile < 768 && selectedStyle!==previewStyles.DESKTOP_PREVIEW ? theme.nonCardTextColor : 'white'}}
        onClick={() => handleOpenLink('redirect_to_landing_page')}
      >
       
         <span>{translate('Powered by')}</span>
      <img src={alfanLogo}></img>
      </div>
    </div>);
  };

  const getTextAlignment = () => {
    return isRtl(theme.displayLocale) ? 'right' : 'left';
  };

  const handleTabChange = (event: any, newValue: string) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const clientSecretParam = urlParams.get("payment_intent_client_secret") || urlParams.get("tap_id");
    const bookUrl = urlParams.get("bookUrl");
    if (urlParams.get("tap_id") || urlParams.get("token") || bookUrl) {
      const q = window.location.search.slice(1, window.location.search.length);
      const b = q.split('&');
      let c = '';
      for (let i=0; i < b.length; i++) {
        c = c + (b[i].includes('token') || b[i].includes('tap_id') || b[i].includes('bookUrl') ? '' : b[i]+'&');
      };
      const url = `${window.location.pathname}?${c}`;
      window.history.pushState({}, document.title, url);
    }
    if (clientSecretParam) {
      setMonetizeObj({...monetizeObj, url: bookUrl || '', type: urlParams.get("linkType") == 'shortCall' ? 'shortCall' : ''});
      setClientSecret(clientSecretParam);
      setMonitizeLinkID('');
      setOpenMonitizeModal(true);
    }
  }, []);

  useEffect(() => {
    if (monitizeLinkID) {
      setClientSecret('');
      setOpenMonitizeModal(true);
    }
  }, [monitizeLinkID]);

  return (
    <div 
      dir={isRtl(theme.displayLocale) ? "rtl": "ltr"}
      className={styles.main}
      style={{
        fontFamily: themeFont,
      }}>
      {/* {mobile > 768 && <img src={profileAvatar} className={styles.mainBackground}/>} */}
      {openMonitizeModal && activePaymentMethod == 'tap' ? <ChargeCardTapModal linksUser={mediakitUser} theme={theme} monetizeObj={monetizeObj} monitizeID={monitizeLinkID} clientSecret={clientSecret} userId={mediakitUser?.userId} handleClose={() => {
        setOpenMonitizeModal(false);
        setMonitizeLinkID('');
        setMonetizeObj({type: '', title: '', note: '', attachment: '', amount: 0, url: '', maxPrice: 1000, minPrice: 1});
        }} /> : null}
      <div className={styles.container}
      >
        <div className={`${styles.desktop_header} ${selectedStyle == previewStyles.MOBILE_PREVIEW ? styles.hide : ''}`}>
          <div className={styles.avatar_container}>
            <img src={profileAvatar} />
          </div>
          <div className={styles.meta_container}>
            <div className={styles.user_name} style={{color: theme.nonCardTextColor, fontFamily: themeFont}}>
              {mediakitUser.fullname}
            </div>
            <div className={styles.location_div}>
              <div>
                <LocationDynamic className={styles.location_wrapper__location} fill={'#7066FF'} />
              </div>
              <div style={{fontFamily: themeFont, color: theme.nonCardTextColor}}>
                {`${(mediakitUser?.city ? `${mediakitUser?.city}${mediakitUser?.country ? ',' : ''}` : '')} ${mediakitUser.country}`}
              </div>
            </div>
            <div className={styles.desktop_description_wrapper} style={{fontFamily: themeFont, ...(!mediakitUser.bio && {marginTop: 0}), color: theme.nonCardTextColor}}>
                {mediakitUser.bio}
            </div>
            <div className={styles.social_media_wrapper}>
              <div className={styles.media_scroll_handler}>{socialMediaData}</div>
            </div>
          </div>
        </div>
        {profileAvatar && <div
          className={`${styles.header} ${styles.hide_desktop} ${selectedStyle == previewStyles.DESKTOP_PREVIEW ? styles.hide : ''}`}
          style={{
            ...(mobile < 768 && {marginBottom: 0}),
            borderRadius: headerBorderRadius,
            ...(socialMediaData && socialMediaData.length === 0 && mobile < 768 && {paddingBottom: 0}),
            ...({
              boxShadow: theme.boxShadow,
            }),
            border: '1px solid ' + theme.borderColor,
            ...(theme.themeName === '07' && {
              borderRadius: 0,
              border: '1px solid ' + theme.borderColor,
            }),
          }}
        >
           {/* Avatar and username start */}
           <div className={`${styles.user_wrapper} ${styles.hide_desktop}`}>
              <img className={styles.avatar} src={profileAvatar} />
              {<div className={styles.transition_div}>
                  <div className={styles.username_wrapper}>
                    <span
                      style={{
                      color: theme.nonCardTextColor,
                      fontFamily: themeFont}}
                      className={styles.username}>
                      {mediakitUser.fullname}</span>
                  </div>
                </div>}
          </div>
           {/* Avatar and username end */}
        </div>}
        <div className={styles.tabsDiv}>
          <div className={`${styles.user_meta} ${styles.hide_desktop}`}>
          {/* Location start */}
          {(mediakitUser.country || mediakitUser?.city) ? <div className={styles.location_container}>
              <div className={styles.pin}>
                <LocationDynamic className={styles.location_wrapper__location}
                  fill={'#7066FF'} />
              </div>
              <span className={styles.locations}
                  style={{
                    fontFamily: themeFont,
                    color: theme.nonCardTextColor}}>
                  {`${(mediakitUser?.city ? `${mediakitUser?.city}${mediakitUser?.country ? ',' : ''}` : '')} ${mediakitUser.country}`}
                </span>
            </div> : <div></div>}
            {/* Location end */}

          {/* Follower Count start */}
          {uniqueFollowerCount != 0 ? <div className={styles.follower_wrapper}>
            <span className={styles.follower}
              style={{
                fontFamily: themeFont}}>
              {uniqueFollowerCount} {translate('Followers')}
            </span>
          </div> : null}
          {/* Follower Count end */}
          
          {/* Bio start */}
          <div
              className={styles.description_wrapper}
              style={{
                fontFamily: themeFont,
                ...(!mediakitUser.bio && {marginTop: 0}),
                color: theme.nonCardTextColor,
              }}>
              {mediakitUser.bio}
          </div>
          {!profileAvatar && <div className={styles.no_avatar_icons}>
          <div className={styles.icon_single}>{socialMediaData}</div>
          </div>}
          {/* Bio end */}
            <div className={styles.social_media_wrapper}>
              <div className={styles.media_scroll_handler}
                      >{socialMediaData}</div>
            </div>
          </div>
        {(ratesLinksData || videoData) && <Tabs
          className={`${styles.tabs} ${classes.tabs}`}
          style={{color: 'black'}}
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor="secondary"
          variant="fullWidth"
        >
          {userRatesLinks?.length > 0 && <Tab style={{color: 'black'}} className={styles.tab_name} value={'rates'} label={translate('rates')}></Tab>}
          {userVideoLinks?.length > 0 && <Tab style={{color: 'black'}} className={styles.tab_name} value={'past_campaigns'} label={translate('past_campaigns')}></Tab>}
        </Tabs>}
        {selectedTab === 'rates' && ratesLinksData}
        {selectedTab === 'past_campaigns' && videoData}
      </div>
        {selectedStyle === previewStyles.DEFAULT &&
          <Footer></Footer>
        }
      </div>
    </div>
  );
};

export default UserPublicProfile;
